import React from "react";
import { Check, Circle } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

export const ProfileCompleteness = ({ completeness }) => {
  const { t, lang } = useLang();
  const percent = completeness?.percent ?? 0;
  const checks = completeness?.checks || {};
  const additional = completeness?.additional || {};
  const r = 34;
  const circ = 2 * Math.PI * r;
  const offset = circ - (percent / 100) * circ;

  return (
    <div
      data-testid="profile-completeness"
      className="bg-[#FFFDF8] rounded-md border border-[#E2DACB] p-6"
    >
      <h3 className="font-serif text-xl font-semibold text-[#2A2521] mb-4">
        {t("farm.profileCompleteness")}
      </h3>
      <div className="flex gap-6 items-center">
        <div className="relative shrink-0" style={{ width: 92, height: 92 }}>
          <svg width="92" height="92" className="-rotate-90">
            <circle cx="46" cy="46" r={r} fill="none" stroke="#EDE7D7" strokeWidth="8" />
            <circle
              cx="46"
              cy="46"
              r={r}
              fill="none"
              stroke="#557448"
              strokeWidth="8"
              strokeLinecap="round"
              strokeDasharray={circ}
              strokeDashoffset={offset}
              style={{ transition: "stroke-dashoffset 0.8s ease" }}
            />
          </svg>
          <span
            data-testid="completeness-percent"
            className="absolute inset-0 flex items-center justify-center font-serif text-2xl font-bold text-[#557448]"
          >
            {percent}%
          </span>
        </div>
        <ul className="space-y-1.5 flex-1">
          {Object.keys(checks).filter(k => !["certifications", "opportunities"].includes(k)).map((k) => {
            const done = !!checks[k];
            return (
              <li key={k} className="flex items-center gap-2 text-sm font-sans">
                {done ? (
                  <Check size={15} className="text-[#557448] shrink-0" />
                ) : (
                  <Circle size={13} className="text-[#C8BBA3] shrink-0" />
                )}
                <span className={done ? "text-[#4A443D]" : "text-[#9A8F80]"}>
                  {t(`completeness.${k}`)}
                </span>
              </li>
            );
          })}
        </ul>
      </div>
      {Object.values(additional).some(Boolean) && <div className="mt-4 pt-4 border-t border-[#E2DACB]">
        <h4 className="font-semibold">{lang === 'it' ? 'Informazioni aggiuntive' : 'Additional information'}</h4>
        <p className="text-sm text-[#6E6258] mt-1">{lang === 'it' ? 'Facoltative: non incidono sulla completezza del profilo.' : 'Optional: they do not affect profile completeness.'}</p>
        <ul className="mt-2 space-y-1.5">{Object.entries(additional).filter(([,present]) => present).map(([key]) => <li key={key} className="flex items-center gap-2 text-sm"><Check size={15} className="text-[#557448]" /><span>{key === 'certifications' ? (lang === 'it' ? 'Certificazioni' : 'Certifications') : (lang === 'it' ? 'Opportunità' : 'Opportunities')}</span></li>)}</ul>
      </div>}
    </div>
  );
};
